import {WorkspaceBookType} from '@shared/core';

const isCoworking = (status: WorkspaceBookType): boolean => {
  if (!status) return false;
  return status.includes('Coworking');
};

export default isCoworking;
